import React, { useEffect, useState } from 'react'
import Cookies from 'js-cookie'
import { useLocation } from 'react-router-dom'

import Navbar from 'components/Navbar/Navbar'
import Discover from 'components/Discover/Discover'
import Footer from 'components/Footer/Footer'
import Menu from 'components/Menu/Menu'

import { useAnimation } from 'utils/hooks'

import SupportChat from 'components/SupportChat/SupportChat';
import CookieConsent from 'components/Modal/CookieConsent/CookieConsent'
import { useRequestDemoModal } from 'context/RequestDemoModalContext'
import RequestDemo from 'components/Modal/CookieConsent/RequestDemo'

function MainContainer({ children }) {
    const { isRequestDemoModalOpen, setRequestDemoModalOpen } = useRequestDemoModal();

    const [isMenuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    // Closed on first render so prerendered HTML and hydration agree; the
    // consent cookie is only readable in the browser.
    const [isOpenCookieConsent, setOpenCookieConsent] = useState(false);
    const { pathname } = useLocation();
    useAnimation()

    useEffect(() => {
        setOpenCookieConsent(Cookies.get('cookie_consent') !== "true");
    }, []);

    useEffect(() => {
        window.onscroll = function () {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };
    }, []);

    return (
        <div>
            <Menu
                className={`${isMenuOpen ? "translate-y-0 z-30 opacity-100 overflow-auto" : "-translate-y-full -z-50 opacity-0"}`}
                scrolled={scrolled}
                onClose={() => setMenuOpen(false)}
                onClickDemo={() => setRequestDemoModalOpen(true)}
            />
            <Navbar
                scrolled={scrolled}
                onClickMenuButton={() => setMenuOpen(true)}
                onClickDemo={() => setRequestDemoModalOpen(true)}
            />
            <div className={`${isMenuOpen ? "hidden" : 'inline'}`}>
                {children}
                <Discover />
                <Footer />
            </div>

            <SupportChat />
            {isOpenCookieConsent && pathname !== "/privacypolicy" && (
                <CookieConsent setOpenCookieConsent={setOpenCookieConsent} />
            )}

            {isRequestDemoModalOpen && (
                <RequestDemo
                    onClose={() => setRequestDemoModalOpen(false)}
                />
            )}
        </div>
    )
}

export default MainContainer